angular.module('tabs', [
  'tabs.files',
  'tabs.tasks',
  'tabs.articles',
  'tabs.concepts',
]);
